{
  "tabs": {
    "overview": "Overview",
    "subaccount": "Sub-accounts",
    "affiliates": "Affiliates",
    "transfers": "Transfers",
    "ledger": "Ledger",
    "documents": "Documents",
    "portfolio": "Portfolio",
    "trades": "Trades"
  },
  "highlights": {
    "goalType": "Goal type: {{goalType}}",
    "timeHorizon": "Time horizon: {{timeHorizon}}",
    "targetAmount": "Target: {{amount}}",
    "riskPreference": "Risk preference: {{level}}",
    "riskLevel": {
      "LEVEL_1": "Level 1",
      "LEVEL_2": "Level 2",
      "LEVEL_3": "Level 3",
      "LEVEL_4": "Level 4",
      "LEVEL_5": "Level 5"
    },
    "suitabilityScore": "Suitability score: {{score}}",
    "goalPortfolio": "Goal portfolio",
    "tradingProcess": "Trading process"
  },
  "timeHorizonDescription": {
    "VERY_SHORT_TERM": "Less than 1 year",
    "SHORT_TERM": "1 - 3 years",
    "MID_TERM": "4 - 6 years",
    "LONG_TERM": "7+ years"
  },
  "linkedSubAccount_one": "1 sub-account linked",
  "linkedSubAccount_other": "{{count}} sub-accounts linked",
  "percentageOfTotalAssets": "{{percentage}} of total assets",
  "riskReturnLevel": "Risk and return level of {{count}}",
  "autoTransferNotSet": "Auto-transfer not set",
  "autoTransferEnabled_one": "Auto-transfer enabled on 1 portfolio",
  "autoTransferEnabled_other": "Auto-transfer enabled on {{count}} portfolios",
  "editGoal": "Edit Goal",
  "dissociateGoalFromHousehold": "Dissociate from Household",
  "edit": {
    "title": "Goal Information",
    "goalType": "Goal Type",
    "targetAmount": "Target Amount",
    "timeHorizon": "Time Horizon",
    "riskPreference": "Risk Preference"
  },
  "holdings": "Holdings",
  "renameGoal": "Rename Goal",
  "closeGoal": "Close Goal",
  "restoreGoal": "Restore Goal",
  "activeGoal": "Active goal",
  "closedGoal": "Closed goal",
  "closeGoalDialog": {
    "title": "Are you sure?",
    "subtitle": "Are you sure you want to close this goal?",
    "continueButton": "Yes - I’m sure",
    "cancelButton": "Cancel"
  },
  "toastMessage": {
    "error": "Something went wrong",
    "success": "Goal has been closed successfully",
    "restoreSuccess": "You have reactivated this goal"
  },
  "closeGoalConfirmationDialog": {
    "title": "Cannot close goal",
    "subtitle": "You need to close all sub-accounts and cancel any scheduled deposits before proceeding",
    "continueButton": "Ok, Got it"
  },
  "household": "Household",
  "changeToHouseholdGoal": "Change to {{name}} Household Goal",
  "associateToHouseholdDialog": {
    "title": "Associate this goal to {{name}} household?",
    "checkingSubaccounts": "Checking goal's sub-accounts",
    "thereAreSubAccounts": "All attached accounts and sub-accounts will also be moved to the household. This includes:",
    "thereAreNoSubAccounts": "Are you sure you want to move this goal to the household?",
    "linkGoalToHousehold": "This goal is not currently associated with a sub-account. Please associate it with a sub-account first. Once done, you'll be able to add the goal to the household.",
    "continueButton": "Yes - I’m sure",
    "gotItButton": "Ok, Got it",
    "cancelButton": "Cancel",
    "success": "Goal has been associated to household.",
    "createSubAccount": "Create sub-account"
  },
  "dissociateGoalDialog": {
    "checkingSubaccounts": "Checking goal's sub-accounts",
    "title": "Dissociate this goal from {{name}} household?",
    "continueButton": "Yes - I’m sure",
    "cancelButton": "Cancel",
    "thereAreSubAccounts": "All attached accounts and sub-accounts will also be removed from the household. This includes:",
    "thereAreNoSubAccounts": "Are you sure you want to remove this goal from the household?",
    "success": "Goal has been dissociated from household."
  }
}
